var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { XText } from '../text/XText';
import { useAsync } from '../../hooks/useAsync';
import { XR } from '../../../xr';
export var XDialogConfirmType;
(function (XDialogConfirmType) {
    XDialogConfirmType["CONFIRM"] = "confirm";
    XDialogConfirmType["DELETE"] = "delete";
})(XDialogConfirmType || (XDialogConfirmType = {}));
export function XDialogConfirm(_a) {
    var _this = this;
    var _b, _c, _d, _e;
    var type = _a.type, query = _a.query, _f = _a.toggleButtonProps, toggleButtonProps = _f === void 0 ? {} : _f, title = _a.title, description = _a.description, _g = _a.confirmButtonProps, confirmButtonProps = _g === void 0 ? {} : _g, onConfirmed = _a.onConfirmed, children = _a.children;
    var confirm = useAsync(function () { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, query.run()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, (onConfirmed === null || onConfirmed === void 0 ? void 0 : onConfirmed())];
                case 2:
                    _a.sent();
                    dialog.close();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); });
    if (type === XDialogConfirmType.CONFIRM) {
        toggleButtonProps.children = (_b = toggleButtonProps.children) !== null && _b !== void 0 ? _b : 'Confirm';
        confirmButtonProps.children = (_c = confirmButtonProps.children) !== null && _c !== void 0 ? _c : 'Confirm';
        confirmButtonProps.color = 'primary';
    }
    if (type === XDialogConfirmType.DELETE) {
        toggleButtonProps.children = (_d = toggleButtonProps.children) !== null && _d !== void 0 ? _d : 'Delete';
        toggleButtonProps.color = 'error';
        confirmButtonProps.children = (_e = confirmButtonProps.children) !== null && _e !== void 0 ? _e : 'Delete';
        confirmButtonProps.color = 'error';
    }
    var dialog = XR.useDialog({
        toggleElement: React.createElement(XR.Button, __assign({}, toggleButtonProps)),
        content: (React.createElement(XText, { align: 'center' },
            React.createElement("div", null, "\u00A0"),
            title && (React.createElement(XR.Section, null,
                React.createElement(XText, { weight: 3, size: 1 }, title))),
            description && (React.createElement(XR.Section, null,
                React.createElement(XText, null, description))),
            children)),
        footer: (React.createElement(XR.Section, { flexChildren: true, gap: 2 },
            React.createElement(XR.Button, { onClick: function () { return dialog.close(); }, disabled: confirm.isLoading }, "Close"),
            React.createElement(XR.Button, __assign({}, confirmButtonProps, confirm.buttonProps)))),
        size: 'SMALL',
    });
    return dialog.element;
}
